import SplitView from './split-view.element.js';

export default SplitView;

SplitView.define('wje-split-view', SplitView);
